import { render } from "./update-contract.vue?vue&type=template&id=08afb12c&scoped=true&ts=true"
import script from "./update-contract.vue?vue&type=script&lang=ts"
export * from "./update-contract.vue?vue&type=script&lang=ts"

import "./update-contract.vue?vue&type=style&index=0&id=08afb12c&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08afb12c"]])

export default __exports__